"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgSpam = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_SPAM", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M10.282.282a.962.962 0 0 0 0 1.36L11.64 3l-1.357 1.357a.962.962 0 1 0 1.36 1.36L13 4.36l1.358 1.358a.962.962 0 0 0 1.36-1.36L14.36 3l1.357-1.357a.962.962 0 0 0-1.36-1.36L13 1.64 11.642.282a.962.962 0 0 0-1.36 0Z" }),
    React.createElement("path", { d: "M11.332 8.982a3.964 3.964 0 0 1-2.328-.5L8 9.484l-3.42-3.42a78.81 78.81 0 0 1 2.54-.061 3.982 3.982 0 0 1 .018-2c-3.43.028-5.4.225-6.37.362-.454.065-.768.456-.768.915v9.438c0 .46.314.85.768.915C1.817 15.781 4.035 16 8 16c3.965 0 6.183-.218 7.232-.367.454-.064.768-.455.768-.914V8.882a3.982 3.982 0 0 1-2-.02v4.903c-1.176.115-3.094.235-6 .235s-4.824-.12-6-.235V6.314l5.293 5.293a1 1 0 0 0 1.414 0l2.625-2.625Z" }))); };
exports.default = SvgSpam;
